import IePolyfills from './iePolyfills';
import MainNavigation from './main-navigation';
import LangMenuDropdown from './lang-selector';
import MobileNav from './mobile-nav';
import LazyImage from './lazy-images';
import PubSub from './content-hub';
import RelatedContent from './related-content';
import FilterList from './filter-list';
import UrlHandler from './url-handler';
import ListsContent from './lists-content';
import GridListsContent from './grid-lists-content';
import VoyageGridItemClassUpdater from './voyage-grid-item-class-updater';
import Glide from "@glidejs/glide";
import DropdownLinks from './dropdown-links';
import { removeExpandableListeners,addExpandableListeners } from './voyage-expandable-handler';
import voyageCarouselHandler from './voyage-carousel-handler';
import handleUnorthodoxGridItems from './voyage-unorthodox-list-handler';
import {addEventListeners} from './voyage-anchor-menu-handler';
import populateAnchorMenuByTags from './voyage-anchor-menu-populator';
import DomHelper from './helpers/dom-helper';
import ArrayHelper from './helpers/array-helper';
import IconHelper from './helpers/icon-helper';
import GUIDHelper from './helpers/guid-helper';
import DateTimeHelper from './date-time-handling';
import QueryStringHelper from './helpers/query-string-helper';
import APIHelper from './helpers/api-helper';
import ObjectHelper from './helpers/object-helper';
import DeviceHelper from './helpers/device-helper';
import voyageInsightsFilterTitle, { voyageInsights2FilterTitle } from './voyage-insight-filter-title';
import truncate from './helpers/truncate';
import ElasticSearchHelper from './elastic-search-helper';
import Authors from './authors';
import IRScroll from './ir-scroll';
import Tabs from './tabs';
import sliderHandler from './slider-handler';
import WizardSelector from './wizard-selector';
import {voyageToughtLeaderCounterAnimation} from './voyage-tought-leader-counter-animation';

const Main = {
  init: function() {
    window.IePolyfills = new IePolyfills();

    /* Helpers */
    window.DomHelper = DomHelper;
    window.ArrayHelper = ArrayHelper;
    window.GUIDHelper = GUIDHelper;
    window.IconHelper = IconHelper;
    window.QueryStringHelper = QueryStringHelper;
    window.DateTimeHelper = DateTimeHelper;
    window.APIHelper = APIHelper;
    window.ObjectHelper = ObjectHelper;
    window.DeviceHelper = DeviceHelper;
    window.ElasticSearchHelper = ElasticSearchHelper;

    /* Main components */
    window.Authors = new Authors();
    window.LazyImage = new LazyImage();
    window.mainNavigation = new MainNavigation();
    window.MobileNav = new MobileNav();
    window.languageSelector = new LangMenuDropdown();
    window.ListsContent = new ListsContent();
    window.pubSubEvents = new PubSub();
    window.RelatedContent = RelatedContent;
    window.FilterList = new FilterList();
    window.UrlHandler = new UrlHandler();
    window.GridListsContent = new GridListsContent();
    window.VoyageGridItemClassUpdater = VoyageGridItemClassUpdater();
    window.Glide = Glide;
    window.DropdownLinks = DropdownLinks;
    window.removeExpandableListeners = removeExpandableListeners();
    window.addExpandableListeners= addExpandableListeners();
    window.voyageCarouselHandler = voyageCarouselHandler();
    window.handleUnorthodoxGridItems=handleUnorthodoxGridItems();
    window.addEventListeners=addEventListeners();
    window.populateAnchorMenuByTags = populateAnchorMenuByTags();
    window.voyageInsightsFilterTitle = voyageInsightsFilterTitle;
    window.voyageInsights2FilterTitle = voyageInsights2FilterTitle;
    window.truncate = truncate;
    window.IRScroll = new IRScroll();
    window.Tabs = new Tabs();
    window.sliderHandler = sliderHandler();
    window.WizardSelector = WizardSelector;
    window.voyageToughtLeaderCounterAnimation = voyageToughtLeaderCounterAnimation;
  },
};

document.addEventListener(
  'DOMContentLoaded',
  () => {
    var dropdownLinks = new window.DropdownLinks();
    dropdownLinks.init();
  },
  false
)

Main.init();
